const routesPaths = {
  site: '/:siteId',
  siteEdit: '/:siteId/edit/',
  siteNew: '/new',
  sites: '/',
};

export default routesPaths;
